"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inject = void 0;
var add_parameter_meta_1 = require("../metadata/add-parameter-meta");
var metadata_keys_1 = require("../metadata/metadata-keys");
var error_messages_1 = require("../constants/error-messages");
function inject(serviceIdentifier) {
    return function (target, targetKey, targetIndex) {
        if (serviceIdentifier === undefined) {
            // eslint-disable-next-line new-cap
            throw new Error(error_messages_1.INJECT_DECORATOR_PARAMETER_ERROR(target.name, targetKey, targetIndex));
        }
        if (typeof targetIndex !== 'number') {
            // 属性注入
            throw new Error(error_messages_1.INJECT_DECORATOR_MISUSED);
        }
        else {
            // 构造函数注入
            add_parameter_meta_1.addTypeParameterMeta(metadata_keys_1.CLASS_CONSTRUCTOR_DEPS, target, targetKey, serviceIdentifier, targetIndex);
        }
    };
}
exports.inject = inject;
//# sourceMappingURL=inject-decorator.js.map